import {forEach, size} from 'lodash';

export const parseAdmissionTemplateVars = (vars, template) => {
    if (!template) {return ''}
    let result = template;
    if (!vars.vars || !vars.values) {
        console.log('parseAdmissionTemplateVars - invalid vars', vars);
    } else {
        vars.vars.forEach((data, key) => {
            result = result.replaceAll(data, vars.values[key] ? vars.values[key] : '');
        })
    }
    if (size(vars.extraFields)) {
        forEach(vars.extraFields, (value, key) => {
            result = result.replaceAll("{{"+key+"}}", value ? value : '');
        });
    }

    return result;
}

export const lastWordInString = (str) => str.split(" ").splice(-1)[0];